





import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
@Component
export default class MeasureDiv extends Vue {
    private div: HTMLElement | null = null;
    private styles: string = '';
    private text: string = '';
    private allowCalc: boolean = true;
    private id: number = 0;

    public height(text: string, styles: string) {
        this.styles = styles;
        const result = this.div?.clientHeight;

        return this.div?.clientHeight;
    }

    public getId() {
        this.id = this.id + 1;

        return this.id;
    }

    public width(text: string, styles: string) {
        this.text = text;
        this.styles = styles;
        const result = this.div?.clientWidth;

        return this.div?.clientWidth;
    }

    public addHeight(value: number, text: string, styles: string) {
        if (!this.allowCalc) {
            return null;
        }

        const height = this.height(text, styles);
        return 38;
        return value + height!;
    }

    public addWidth(value: number, text: string, styles: string) {
        const width = this.width(text, styles);
        return value + width!;
    }

    private mounted() {
        const divName = 'measureDiv';
        this.div = this.$refs[divName] as HTMLElement;
        this.allowCalc = true;
    }
}
